import React from 'react';
const Input = props => {
    return (
        <input
            {...props}
            type={props.type}
            className={props.class}
            style={{ ...props.style }}

        />
    );
};
export default Input;